import React, { useContext, useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getProfileDataByDay } from '../../NecttosComp/APICaller/ApiServices';
import { Body, Main, Header } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import HandleProceed from './HandleProceed';
import { NecttosContext } from '../../context/NecttosContext';
import Input2 from '../../NecttosComp/Input/Input2';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';

function VerificationStudent({ userId, isStudent, keyData, TimerFuncion, stateData, setStateData, parentOnClose, onClose, toast }) {
	const { collegeId } = useContext(NecttosContext);
	const [values, setValues] = useState('');
	const [states, setStates] = useState({ admissionNo: '' });
	const [editMode, setEditMode] = useState(false);
	const [singleCheck, setSingleCheck] = useState(false);
	const [originalNo, setOriginalNo] = useState('');
	const [state, setState] = useState({});
	const [verifications, setVerifications] = useState({});
	const [isModalDepartment, setIsModalDepartment] = useState(false);
	const [remarks, setRemarks] = useState({ remarks: '', calculatedIndex: '' });
	const [emergencyLevel, setEmergencyLevel] = useState('');
	const [admnPlace, setAdmnPlace] = useState('');

	const emergencyOptions = [
		{ label: 'None', value: '' },
		{ label: 'Distance More Than 100km', value: 'Distance More Than 100km' },
		{ label: 'Physical Illness or Disability', value: 'Physical Illness or Disability' },
		{ label: 'Hailing From Attappadi / Parambikkulam / Munnar', value: 'Hailing From Attappadi / Parambikkulam / Munnar' },
	];

	const { data, isFetched } = useQuery(['getProfileDataTc', userId, collegeId], () => getProfileDataByDay({ userId, collegeId, days: 15 }), {
		refetchOnWindowFocus: false,
		refetchOnMount: false,
	});

	const getAdmissionNumberPlace = async (collegeId) => {
		try {
			const instance = await getAxiosTokenInstance();
			const { data } = await instance.get('/college/admissionProcess2/getAdmissionNumberPlace', {
				params: { collegeId },
			});
			console.log('API Response: ', data);
			return data;
		} catch (error) {
			console.error('Error fetching admission number place:', error?.message || error);
			throw error;
		}
	};

	useEffect(() => {
		if (data?.profile) {
			setState(data.profile);
		}
	}, [isFetched]);

	useEffect(() => {
		if (keyData === 'department' && data?.keysByCategory) {
			const defaultVerificationState = {};
			data.keysByCategory.forEach((cat) => {
				defaultVerificationState[cat.title.toLowerCase()] = false;
			});
			setVerifications(defaultVerificationState);
		} else {
			setSingleCheck(false);
		}
	}, [keyData, data?.keysByCategory]);

	useEffect(() => {
		const fetchData = async () => {
			const instance = await getAxiosTokenInstance();
			try {
				const resp = await instance.get('/college/admissionProcess2/getFalseNumber', {
					params: { collegeId },
				});
				if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
				const no = parseInt(resp.data?.admissionNo || '0', 10);
				const incremented = (no + 1).toString();
				setStates((prev) => ({ ...prev, admissionNo: incremented }));
				setOriginalNo(no.toString());
			} catch (error) {
				console.error('Error fetching admission number:', error);
			}
		};
		fetchData();
	}, [collegeId]);

	useEffect(() => {
		const fetchAdmnPlace = async () => {
			try {
				const res = await getAdmissionNumberPlace(collegeId);
				setAdmnPlace(res?.data?.verificationWindows?.giveAdmissionNumber);
			} catch (err) {
				console.error('Failed to fetch admission number place', err);
			}
		};
		fetchAdmnPlace();
	}, [collegeId]);


	const handleSave = async () => {
		const instance = await getAxiosTokenInstance();
		try {
			const resp = await instance.post('/college/admissionProcess2/updateFalseNumber', {
				collegeId,
				admisionNo: states.admissionNo,
			});
			if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
			setEditMode(false);
			setOriginalNo(state.admissionNo);
			alert('changed the admission number, Series ');
		} catch (error) {
			console.error('Error updating admission number:', error);
		}
	};

	const handleCheck = (section) => {
		setVerifications((prev) => ({ ...prev, [section]: !prev[section] }));
	};

	const handleProceed = () => {
		setState({ ...state, handleProceed: true });
	};

	const handleClose = () => onClose();
	const profile = data?.profile;
	const keysByCategory = data?.keysByCategory || [];
	const allChecked = keyData === 'department' ? Object.values(verifications).length === keysByCategory.length && Object.values(verifications).every(Boolean) : singleCheck;

	return (
		<Main width='95vw' height='90vh' title='Student Verification'>
			<Header>
				<div className='flex items-center'>
					<h1 className='text-xl font-semibold text-slate-800 dark:text-slate-100'>
						Student Verification
						<span className='ml-2 text-sm font-normal text-slate-500 dark:text-slate-400'>#{profile?.applicationNo}</span>
					</h1>
				</div>
				<div className='flex justify-end gap-3'>
					<Button type='close' onClick={handleClose}>
						Cancel
					</Button>
					<Button type='complete' onClick={handleProceed} disabled={!allChecked}>
						Complete Verification
					</Button>
				</div>
			</Header>

			<Body>
				<div style={styles}>
					<div className='flex flex-wrap gap-4 px-4 overflow-auto max-h-[calc(90vh-120px)]'>
						{keysByCategory?.map((categ, index) => (
							<div key={categ.title} className='w-full md:w-[48%] bg-slate-100 dark:bg-slate-800 rounded-xl p-4 border dark:border-slate-700'>
								<h3 className='text-lg font-semibold text-slate-700 dark:text-white mb-3'>{categ.title}</h3>
								<table className='w-full text-sm text-left text-slate-700 dark:text-slate-200'>
									<tbody>
										{categ.keys.map((item) => {
											const val = state?.[item._id];

											return (
												<tr key={item._id} className='border-t border-slate-200 dark:border-slate-600'>
													<td className='py-2 pr-3 font-medium w-1/3'>{item?.shortName || item?.name}</td>
													<td className='py-2'>
														{(() => {
															if (item.type === 'checkbox') {
																let checkboxValue = val;

																if (checkboxValue === undefined && state?.certificates) {
																	if (state.certificates.hasOwnProperty(item._id)) {
																		checkboxValue = state.certificates[item._id];
																	} else {
																		const certKey = Object.keys(state.certificates).find((key) => {
																			if (item._id === 'degree certificate' && key === 'CC') return true;
																			if (item._id === 'arts' && key === 'ARTS') return true;
																			if (item._id === 'tlm' && key === 'TLM') return true;
																			if (item._id === 'utl' && key === 'UTL') return true;
																			if (item._id === 'nss' && key === 'NSS\\NCC') return true;
																			if (item._id === 'community' && key === 'COMMUNITY') return true;
																			if (item._id === 'ews' && key === 'EWS') return true;
																			if (item._id === 'pwd' && key === 'PWD') return true;

																			return key.toLowerCase().includes(item._id.toLowerCase()) || item._id.toLowerCase().includes(key.toLowerCase());
																		});

																		if (certKey) {
																			checkboxValue = state.certificates[certKey];
																		}
																	}
																}

																if (checkboxValue && typeof checkboxValue === 'object' && !Array.isArray(checkboxValue)) {
																	return (
																		<div className='space-y-1'>
																			{Object.entries(checkboxValue).map(([key, value]) => (
																				<div key={key} className='flex items-center gap-2 text-sm'>
																					<input type='checkbox' checked={!!value} readOnly className='w-4 h-4 text-blue-600' />
																					<span className={value ? 'text-green-700' : 'text-gray-500'}>{key}</span>
																				</div>
																			))}
																		</div>
																	);
																}

																return (
																	<div className='flex items-center gap-2'>
																		<input type='checkbox' checked={!!checkboxValue} readOnly className='w-4 h-4 text-blue-600' />
																		<span className={checkboxValue ? 'text-green-700' : checkboxValue === false ? 'text-red-500' : 'text-gray-500'}>{checkboxValue === undefined ? 'Not Set' : checkboxValue ? 'Submitted' : 'Missing'}</span>
																	</div>
																);
															}

															if (item.type === 'declaration') {
																return (
																	<div className='flex items-center gap-2'>
																		<input type='checkbox' checked={!!val} readOnly className='w-4 h-4 text-blue-600' />
																		<span className={val ? 'text-green-700' : 'text-gray-500'}>{val ? 'Declared' : 'Not Declared'}</span>
																	</div>
																);
															}

															if (Array.isArray(val)) {
																console.log(`Rendering as array for ${item._id}`);
																return val.length > 0 ? val.join(', ') : '-';
															}

															if (val && typeof val === 'object') {
																const allBooleans = Object.values(val).every((v) => typeof v === 'boolean');

																if (allBooleans) {
																	console.log(`Rendering as inferred checkbox object for ${item._id}`);
																	return (
																		<div className='space-y-1'>
																			{Object.entries(val).map(([key, value]) => (
																				<div key={key} className='flex items-center gap-2 text-sm'>
																					<input type='checkbox' checked={!!value} readOnly className='w-4 h-4 text-blue-600' />
																					<span className={value ? 'text-green-700' : 'text-gray-500'}>{key}</span>
																				</div>
																			))}
																		</div>
																	);
																}

																const first = Object.values(val)[0];
																return first ? first.toString() : '-';
															}

															return val?.toString() || '-';
														})()}
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
								{keyData === 'department' && (
									<div className='mt-4 p-2 bg-blue-50 dark:bg-blue-900/10 rounded-lg border border-blue-100 dark:border-blue-900/30'>
										<label className='flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-200'>
											<input type='checkbox' checked={verifications[categ.title.toLowerCase()] || false} onChange={() => handleCheck(categ.title.toLowerCase())} className='w-4 h-4 text-blue-600 dark:text-blue-500' />
											"I, Department Coordinator/HOD, verify that the above data for {categ.title.toLowerCase()} has been checked with original documents and is found to be correct. I confirm that the above information is accurate."
										</label>
									</div>
								)}
							</div>
						))}

						{keyData !== 'department' && (
							<div className='w-full md:w-[95%] bg-slate-100 dark:bg-slate-800 rounded-xl p-4 border dark:border-slate-700 mt-6'>
								<label className='flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-200'>
									<input type='checkbox' checked={singleCheck} onChange={() => setSingleCheck((prev) => !prev)} className='w-4 h-4 text-blue-600 dark:text-blue-500' />
									"I, as a {keyData} authority, verify that the data has been checked with original documents and is found to be correct."
								</label>
							</div>
						)}
					</div>
				</div>

				{keyData === admnPlace && (
					<>
						<div className='mt-10'>Admission number That will be Assigned (only for office use)</div>
						<div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
							<Input2 type='text' returnKey='admissionNo' state={states} setState={setStates} label='Admission Number' className='w-[300px] text-black' disabled={!editMode} />
							{editMode ? <button onClick={handleSave}>Save</button> : <button onClick={() => setEditMode(true)}>Edit</button>}
						</div>
					</>
				)}
			</Body>

			{/* {isModalDepartment && (
				<div className='fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center'>
					<div className='bg-white dark:bg-slate-800 rounded-xl shadow-lg p-6 w-[90%] max-w-md'>
						<h2 className='text-lg font-bold text-slate-800 dark:text-white mb-4'>Submit Remarks (optional)</h2>

						<div className='mb-4'>
							<label className='block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1'>Calculated Index</label>
							<Input2 type='text' returnKey='calculatedIndex' state={remarks} setState={setRemarks} className='w-full' />
						</div>

						<div className='mb-4'>
							<label className='block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1'>Remarks</label>
							<Input2 type='text' returnKey='remarks' state={remarks} setState={setRemarks} className='w-full' />
						</div>

						<div className='mb-4'>
							<label className='block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1'>Emergency Level</label>
							<select value={emergencyLevel} onChange={(e) => setEmergencyLevel(e.target.value)} className='w-full border rounded-md px-3 py-2 text-sm bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100'>
								{emergencyOptions.map((option) => (
									<option key={option.value} value={option.value}>
										{option.label}
									</option>
								))}
							</select>
						</div>

						<div className='flex justify-end gap-3 mt-4'>
							<Button
								type='complete'
								onClick={() => {
									setState((prev) => ({
										...prev,
										remarks: remarks.remarks,
										calculatedIndex: remarks.calculatedIndex,
										emergencyLevel,
									}));
									setIsModalDepartment(false);
									setTimeout(() => setState((prev) => ({ ...prev, handleProceed: true })), 100);
								}}>
								Submit
							</Button>
							<Button type='close' onClick={() => setIsModalDepartment(false)}>
								Cancel
							</Button>
						</div>
					</div>
				</div>
			)} */}

			{state?.handleProceed && (
				<HandleProceed
					userId={userId}
					isStudent={true}
					keyData={keyData}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					toast={toast}
					onClose={() => {
						setState({ ...state, handleProceed: false });
						setTimeout(() => {
							if (parentOnClose) parentOnClose();
							onClose();
						}, 100);
					}}
				/>
			)}
		</Main>
	);
}

const styles = {
  overflowY: 'scroll',
  height: '100%', 
  scrollbarWidth: 'thin',
  scrollbarColor: '#94a3b8 #e2e8f0', 

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#94a3b8',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#e2e8f0',
    borderRadius: '4px',
  },

  '&::-webkit-scrollbar-thumb:inactive': {
    backgroundColor: '#94a3b8', 
  },
};



export default VerificationStudent;
